const initModalResponse = () => {
    const modal = document.querySelector(".modal");
    const closeModal = document.querySelector(".modal .close-icon");
    if (modal && closeModal) {
        const url = new URL(window.location.href);
        const modalResponse = url.searchParams.get("contact") === "1";
        const errorResponse = url.searchParams.get("contact") === "0";
        if (modalResponse || errorResponse) {
            modal.classList.remove('not-visible');
            closeModal.classList.add("active");
            if (modalResponse) {
                modal.classList.add('success');
            }
            if (errorResponse) {
                modal.classList.add('error');
            }
        }
        closeModal.addEventListener('click', () => {
            modal.classList.add('not-visible');
            closeModal.classList.remove("active");
        });
    }
};
